import { render, staticRenderFns } from "./out_product_detail.vue?vue&type=template&id=8a0cfa52&scoped=true&"
import script from "./out_product_detail.vue?vue&type=script&lang=js&"
export * from "./out_product_detail.vue?vue&type=script&lang=js&"
import style0 from "./out_product_detail.vue?vue&type=style&index=0&id=8a0cfa52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0cfa52",
  null
  
)

export default component.exports